import { useRef, useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { TrustBar } from "@/components/landing/TrustBar";
import { FeaturedProducts } from "@/components/landing/FeaturedProducts";
import { Benefits } from "@/components/landing/Benefits";
import { Testimonials } from "@/components/landing/Testimonials";
import { Newsletter } from "@/components/landing/Newsletter";
import { Footer } from "@/components/landing/Footer";
import { MobileCtaBar } from "@/components/landing/MobileCtaBar";
import { preloadLandingImages } from "@/lib/preloadImages";
import { useSeo, SITE } from "@/lib/seo";

export default function Landing() {
  const lenisRef = useRef(null);
  useSeo({
    title: "Alpha Omega Vitality | Premium Vitamins & Supplements",
    description:
      "Clinically dosed, third-party tested vitamins, nootropics, adaptogens & longevity formulas. Sourced & shipped in the USA. Clinical precision, natural alchemy.",
    canonical: `${SITE}/`,
    keywords:
      "vitamins, supplements, nootropics, adaptogens, NAD+, magnesium glycinate, vitamin D3, colostrum, methylene blue, longevity, Alpha Omega Vitality",
    image: "https://cdn.shopify.com/s/files/1/0693/0287/8457/files/alphaorangedesktop.webp",
  });
  useEffect(() => {
    window.lenis = lenisRef.current?.lenis;
    preloadLandingImages();
  });
  return (
    <ReactLenis root ref={lenisRef} options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="grain relative bg-[#f4f1eb]">
        <Toaster position="top-center" richColors />
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <TrustBar />
          <FeaturedProducts />
          <Benefits />
          <Testimonials />
          <Newsletter />
        </main>
        <Footer />
        <MobileCtaBar />
        <div className="h-20 lg:hidden" aria-hidden="true" />
      </div>
    </ReactLenis>
  );
}
